import { render } from "./DettaglioUtente.vue?vue&type=template&id=5c4d35f4&ts=true"
import script from "./DettaglioUtente.vue?vue&type=script&lang=ts"
export * from "./DettaglioUtente.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__